import { Fragment } from "react";
import style from "./TerminateText.module.css";
import useSharedData from "../../../../../../hooks/useSharedData";

function TerminateText() {
  const { user } = useSharedData();

  return (
    <Fragment>
      <div className="d-flex justify-content-between align-items-center">
        <img style={{ width: 100 }} src="../logoTemp.png" alt="" />
        <p className="m-0">
          <span>تاریخ: </span>
          <span>{new Date().toLocaleDateString("fa-IR")}</span>
        </p>
      </div>

      <p className="text-center mt-5 mb-3">
        <strong style={{ fontSize: 28 }}>اعلامیه فسخ قرارداد</strong>
        <span style={{ fontSize: 22 }}> (پایان قرارداد)</span>
      </p>

      <div id="printArea">
        <h6>به نام خدا</h6>
        <p className="mb-2 mt-4" style={{ textAlign: "justify" }}>
          <span>بدینوسـیله اینجانب </span>
          <strong>
            <span>{user.name}</span>
            {user.type === 0 && <span> {user.family}</span>}
          </strong>
          <span>{user.type === 0 ? " با کد ملی " : " با شناسه ملی شرکت "}</span>
          <strong>{user.nationalCode}</strong>
          <span> نماینده سامانه آواکس شهر </span>
          <strong>{user.address.city.faName} </strong>
          <span>
            خاتمه همکاری خود را به عنوان نماینده شرکت پیشرو ترابر مهیار شرق
            اعلام می‌دارم و اعلام میکنم کلیه حق و حقوق خود را طبق قرارداد فی
            مابین دریافت نموده‌ام و هیچگونه ادعایی چه قبل و چه بعد از فسخ
            قرارداد را نخواهم داشت.
          </span>
        </p>
        <p className="mb-2" style={{ textAlign: "justify" }}>
          &nbsp;&nbsp;&nbsp;&nbsp;طبق ماده <strong>4</strong> بند 7-4
          &quot;قرارداد فی مابین هیچ گونه حقی در زمینه استخدامی و بیمه تامین
          اجتماعی برای نماینده نداشته و نخواهد داشت.&quot;
        </p>
        <p className="mb-0" style={{ textAlign: "justify" }}>
          همچنین متعهد می‌شوم هیچگونه حساب مالی با اشخاص و ارگان های دولتی
          (سازمان تامین اجتماعی ، دارایی و ...) و خصوصی نداشته ام و تسویه کامل
          انجام شده است، چنانچه خلاف آن ثابت شود شرکت می‌تواند طبق قرارداد از
          محل تضامین سپرده نزد خود جبران خسارت نماید. پس از دریافت تضامین و
          مدارک نیز موردی کشف شود ، شخصا جوابگو خواهم بود.
        </p>
        <p style={{ textAlign: "justify" }}>
          لازم به توضیح است متعهد می‌شوم تعهدات لازم نسبت به قرارداد محرمانگی در
          خصوص حفظ اطلاعات شرکت را رعایت نمایم.
        </p>

        <p className={"text-start mt-2 mb-0 " + style.printSignature}>
          <span>امضا و اثر انگشت</span>
        </p>
      </div>
    </Fragment>
  );
}

export default TerminateText;
